import { calculateFinalPositions } from "model/Positions";
import { MatchTeams } from "model/Match/MatchTeams";
import { nonUndefined } from "Utility";
import { applyScoreOverrides, Scores } from "model/Scores";
import { mapMatchSetBase } from "../FsMatchSet";
import { FsKnockoutSet } from "db/model/match/Set/Knockout/FsKnockoutSet";
import { KnockoutSet } from "model/Match/Set/Knockout/KnockoutSet";
import { mapKnockoutFormat } from "./FsKnockoutFormat";
import { mapKnockoutTracks } from "./FsKnockoutTrack";
import { getNonForfeitedRosterIds } from "model/Roster/Roster";

export const mapKnockoutSet = (
  fsModel: FsKnockoutSet,
  teams: MatchTeams,
  isNewGolden: boolean
): KnockoutSet | undefined => {
  if (!fsModel.format) {
    return undefined;
  }

  const format = mapKnockoutFormat(fsModel.format);
  if (!format) {
    return undefined;
  }

  var scores: Scores = {};
  getNonForfeitedRosterIds(teams.rosters).forEach(
    (rosterId) => (scores[rosterId] = format.startingLives)
  );

  const tracks = mapKnockoutTracks(
    nonUndefined(fsModel.tracks ?? []),
    teams.rosters,
    teams.scope,
    scores,
    format.lives,
    format.roundsPerTrack,
    format.noKoRound,
    format.startingLives,
    isNewGolden
  );

  applyScoreOverrides(scores, fsModel.scoreOverrides);
  const isComplete =
    fsModel.overrideComplete ||
    calculateIsComplete(scores, format.playTillLeft);

  const finalPositions = calculateFinalPositions(
    isComplete,
    scores,
    compareScores
  );

  // todo temp fix
  if (Object.values(scores).every((s) => s === format.startingLives)) {
    scores = {};
  }

  return {
    ...mapMatchSetBase(fsModel, isComplete, finalPositions, scores),
    format,
    tracks,
    type: "Knockout",
  };
};

const calculateIsComplete = (
  scores: Scores,
  playTillLeft: number | undefined
) => {
  const numLeft = Object.values(scores).filter((s) => s > 0).length;
  return numLeft <= (playTillLeft ?? 1);
};

// todo - Apply tiebreakers here
const compareScores = (scores: Scores, a: string, b: string) => {
  return scores[b] - scores[a];
};
